import { HomePageSearchBar } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';

export function SearchWidgetContent() {
  return (
    <SearchContextProvider>
      <HomePageSearchBar placeholder="Buscar componentes, APIs, documentación, decisiones…" />
    </SearchContextProvider>
  );
}

export const searchWidget = HomePageWidgetBlueprint.make({
  name: 'search',
  params: {
    name: 'search',
    title: 'Buscar',
    components: async () => ({ Content: SearchWidgetContent }),
  },
});
